import { render, staticRenderFns } from "./RecomResale.vue?vue&type=template&id=79d0f6c6"
import script from "./RecomResale.vue?vue&type=script&lang=js"
export * from "./RecomResale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports